import styled from "styled-components";
import { breakpoint } from "@utilities";
import { AppModuleLayout } from "@layouts";
import { useEffect } from "react";

export const CommissionLearnMore = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <AppModuleLayout>
            <StyledCommission>
                <div className="commissionWrapper">
                    <div className="commissionContent">
                        <h2 className="heading">Learn More About Commissions</h2>
                        <br />
                        <br />
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">What Is a Commission Agent?</h3>
                            <p className="contentText">
                                A Commission Agent can earn commission on eligible bookings made
                                through the platform—whether booking for themselves or for others.
                                <br />
                                Once upgraded, commission tools appear across the app, allowing you
                                to track commission, adjust sell prices, and view commission history
                                in real time.
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">
                                Who Can Become a Commission Agent?
                            </h3>
                            <p className="contentText">
                                To upgrade to a Commission Agent:
                                <br />
                                <br />
                                <li>You must first be a Rewards (Points) Member</li>
                                <br />
                                <li>
                                    Your profile and required member and bank details for payments
                                    must be completed (Currently an Australian Bank Account and ABN
                                    is required)
                                </li>
                                <br />
                                If you are not yet a points user, you'll be prompted to upgrade
                                before continuing.
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">
                                How Do I Upgrade to a Commission Agent?
                            </h3>
                            <p className="contentText">
                                <li>
                                    Ensure your account is already upgraded to Rewards (Points)
                                    Member.
                                </li>
                                <br />
                                <li>
                                    Tap <b>Upgrade to Commission</b> from the app.
                                </li>
                                <br />
                                <li>Enter all required member and bank details.</li>
                                <br />
                                <li>Review the information and confirm the upgrade.</li>
                                <br />
                                Once confirmed, your account will be upgraded successfully, and your
                                commission balance will start at $0.
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">How Do Commissions Work?</h3>
                            <p className="contentText">
                                <li>
                                    <b>Earning Commission:</b> Earn commission on eligible bookings
                                    based on the final sell price of the order.
                                </li>
                                <br />
                                <li>
                                    <b>Order-Level Calculation:</b> Commission is calculated at the
                                    order level, not per individual product.
                                </li>
                                <br />
                                <li>
                                    <b>Availability Timing:</b> Commissions are initially marked as
                                    pending. Once the related travel date has passed, the commission
                                    becomes available and is paid out to your registered bank
                                    account.
                                </li>
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">Adjusting Commission at Checkout</h3>
                            <p className="contentText">
                                <li>
                                    If you're a Commission Member, you may see the{" "}
                                    <b>Adjust Sell Price</b> option at checkout.
                                </li>
                                <br />
                                <li>Use the slider to increase or decrease your commission.</li>
                                <br />
                                <li>
                                    As commission changes, the sell price updates proportionally.
                                </li>
                                <br />
                                <li>
                                    Changes apply in real time and are reflected instantly in the
                                    order summary.
                                </li>
                                <br />
                                <li>
                                    You can turn the option off at any time to reset to the default
                                    values.
                                </li>
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">
                                Using Reward Points with Commissions
                            </h3>
                            <p className="contentText">
                                If you have reward points available:
                                <br />
                                <br />
                                <li>
                                    You can apply points and adjust commission in the same order.
                                </li>
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">Where Can I See My Commissions?</h3>
                            <p className="contentText">
                                <li>
                                    <b>Home:</b> A floating banner shows commission owed and total
                                    earned.
                                </li>
                                <br />
                                <li>
                                    <b>Earnings Page:</b> Switch between Points and Commissions
                                    tabs.
                                </li>
                                <br />
                                <li>
                                    <b>Commissions Screen:</b> View current balance, available this
                                    week, pending amounts, and total earnings.
                                </li>
                                <br />
                                <li>
                                    <b>History:</b> Review recent commissions and access full
                                    history with filters.
                                </li>
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">Important to Know</h3>
                            <p className="contentText">
                                <li>Commission is only available to upgraded Commission Agents.</li>
                                <br />
                                <li>
                                    Commission varies per product and is dependent on the Operator.
                                </li>
                                <br />
                                <li>Pending commissions are not immediately withdrawable.</li>
                                <br />
                                <li>
                                    If a booking is modified or refunded, commission amounts may
                                    change.
                                </li>
                                <br />
                                <li>Commission visibility settings affect all relevant screens.</li>
                                <br />
                                <li>
                                    Tax Obligations for Commission payments are for the user and
                                    their Tax Agent to declare.
                                </li>
                            </p>
                        </div>
                        <div className="commissionSection">
                            <h3 className="subSectionHeading">Pro Tips</h3>
                            <p className="contentText">
                                <li>Review pending commissions to plan future earnings.</li>
                                <br />
                                <li>
                                    Adjust the slider to change your commission and the booking
                                    price.
                                </li>
                                <br />
                                <li>
                                    Combine reward points and commission adjustments to optimize
                                    checkout value.
                                </li>
                                <br />
                                <li>
                                    Keep commission visibility on to monitor earnings across the
                                    app.
                                </li>
                            </p>
                        </div>
                    </div>
                </div>
            </StyledCommission>
        </AppModuleLayout>
    );
};

const StyledCommission = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: calc(100vh - 164px);
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;

    .commissionWrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: auto;
        max-width: 1200px;
        width: 100%;
        padding: 0px 24px;
        padding-bottom: 50px;
    }
    .commissionSection {
        margin-top: 20px;
    }

    .commissionContent {
        width: 100%;
        max-width: 1200px;
    }

    .heading {
        font-size: 28px;
        font-weight: 600;
        color: #333;
        margin: 0;
    }

    .subSectionHeading {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin: 0 0 12px 0;
    }

    .contentText {
        font-size: 16px;
        line-height: 1.6;
        color: #555;
        margin: 0;

        li {
            margin-left: 20px;
        }

        b {
            font-weight: 600;
            color: #333;
        }
    }

    ${breakpoint.breakMobile`
        height: calc(100vh - 120px);
        padding: 16px;

        .commissionWrapper {
            padding: 0px 16px;
            padding-bottom: 30px;
        }

        .heading {
            font-size: 24px;
        }

        .subSectionHeading {
            font-size: 18px;
        }

        .contentText {
            font-size: 14px;
        }
    `}
`;
